import axios from 'axios';
import { ForecastActivity } from 'views/planning-prognosis/features/sites/types/forecast-activity.type';

// GET
// /ewosapi/v1/planandprognosis/site/{globalSiteId}/forecast/activities
export const getForecastActivities = async (globalSiteId: string): Promise<ForecastActivity[]> => {
  const res = await axios.get<ForecastActivity[]>(`/ewosapi/v1/planandprognosis/site/${globalSiteId}/forecast/activities`);
  return res.data;
};
